import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './tailwind.css'
import Game from './Pages/Game/Index'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Game />)
